// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mcBl","top":"styles_top__1XdIz","left":"styles_left__225pj","description":"styles_description__1o8ga"};